import { BreadCrumb, Title } from "@funcional/react-ui";
import { useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";

export default function RegisterCleanCPFResult() {
  let { programCode, result }: { programCode: string; result: string } =
    useParams();

  console.log(
    "🚀 ~ file: RegisterCleanCPFResult.tsx:21 ~ RegisterCleanCPFResult ~ status:",
    result
  );
  return (
    <>
      <div className="flex w-full items-center">
        <div className="flex-1">
          <Title marginBottom={0}>CPFs</Title>
        </div>
      </div>

      <BreadCrumb
        items={[
          { path: "/pbm/programs", label: "Programas" },
          {
            path: `/pbm/programs/${programCode}`,
            label: programCode,
          },
          { label: "CPFs", path: `/pbm/programs/${programCode}/cleancpf` },
          { label: "Confirmação" },
        ]}
      />
      <Grid container>
        <Grid item>
          {result === "true" ? (
            <>
              <h6 className="text-md font-medium text-gray-500 mb-4">
                Desativação de CPFs efetuada com sucesso!
              </h6>
            </>
          ) : (
            <>
              <h6 className="text-md font-medium text-gray-500 mb-4">
                Error ao efetuar a Desativação de CPFs, por favor tente
                novamente.
              </h6>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
}
